import { connect } from "react-redux";
import { useState } from "react";
import { ClockCircleOutlined } from "@ant-design/icons";
import { timeFormat, trimmedText } from "./notificationUtility";
import AdminNotification from "./adminNotificaion";
import { updateAdminReadNotification } from "../../../actions/notificationActions";
import { Avatar } from "antd";
import { useHistory } from "react-router-dom";
import { setApplicationModule } from "../../../actions/appActions";
import { useTranslation } from "react-i18next";
import { NotificationBellInAvatarIcon } from "../icons";
import "./notification.css";

const Notifications = ({
	notifications,
	companyId,
	setApplicationModule,
	shoNotificationDetails,
}) => {
	const [isAdminNotificationVisible, setIsAdminNotificationVisible] =
		useState(false);
	const [data, setData] = useState(null);
	// let history = useHistory();
	const { t } = useTranslation();

	const handleNotificationClick = (elm) => {
		shoNotificationDetails(elm);
		if (elm.type === "admin") {
			// setIsAdminNotificationVisible(true);
			setData(elm);
			if (!elm.isRead) updateAdminReadNotification(companyId, elm.key);
		} else {
			// setApplicationModule(ApplicationModule.Internship);
			// history.push("/Internship/ChatRoom", elm);
		}
	};
	// const renderAvatar = (data) => {
	// 	if (data?.image) {
	// 		return <Avatar size={24} src={<img src={data.image} alt="avatar" />} />;
	// 	} else {
	// 		return <Avatar size={24}>{data.name.substring(0, 1)}</Avatar>;
	// 	}
	// };
	let allNotificationJsx = notifications?.map((elm) => (
		<div
			key={elm.key}
			className="notification_itemConteiner"
			style={elm.isRead ? {} : { backgroundColor: "#f2f4f7" }}
			onClick={() => handleNotificationClick(elm)}
		>
			<div className="notificationAvatar">
				{/* <Avatar
					shape="circle"
					size={24}
					src={<NotificationBellInAvatarIcon width={24} height={24} />}
				/> */}
				<NotificationBellInAvatarIcon width={16} height={16} />
			</div>
			<div className="msgDivBody" key="body">
				{/* <div className="msgDivBodyTitle">{trimmedText(elm.title, 25)}</div> */}
				<div className="msgBodyText">{trimmedText(elm.text, 40)}</div>
				<div className="msgDivBodydate">
					<ClockCircleOutlined />
					<span className="time">{timeFormat(elm?.date.toDate())}</span>
				</div>
			</div>
			{}
		</div>
	));

	return (
		<>
			<div className="notification_panelContainer">
				<div className="notificationHeader" key="idHead">
					{t("headerNav_notification_panelHeader")}
				</div>
				<div className="notificationBody" key="idbody">
					{allNotificationJsx}
				</div>
			</div>
			<AdminNotification
				isModalVisible={isAdminNotificationVisible}
				setIsModalVisible={setIsAdminNotificationVisible}
				data={data}
			/>
		</>
	);
};
const mapStateToProps = (state) => ({
	notifications: state.notifications.allNotification,
	companyId: state.company.company?.id,
});

export default connect(mapStateToProps, { setApplicationModule })(
	Notifications
);
